/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
// React
import React from 'react';
import { useState } from 'react';
// redux
import { useDispatch } from 'react-redux';
// actions
import { updateInstance } from '../../actions';
// BASE Components
import BASESvgIcon from '../../../@BASE/core/BASESvgIcon';
import NavLinkAdapter from '../../../@BASE/core/NavLinkAdapter/NavLinkAdapter';
// Material UI Components
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Typography from '@mui/material/Typography';
// Custom Components
import CommentStatusBar from './CommentStatusBar';
import authRoles from '../../auth/authRoles';

function ReplyContentCard(props) {
  const dispatch = useDispatch();
  const { comment, user, searchText, isIMI = false, resource, collection = 'comments' } = props;
  const [internality, setInternality] = useState(
    () => comment.internality ?? false
  );
  const trimmedSearchText = searchText?.trim();

  const commentCategory = collection

  const editLink =
    collection === 'comments'
      ? `${comment.parent}/reply/${comment.id}/edit`
      : `comments/${comment.parent}/reply/${comment.id}/edit`; 

  const replyLink =
    collection === 'comments'
      ? `${comment.id}/reply/new/edit`
      :`comments/${comment.id}/reply/new/edit`;

  const highlightText = (text, query) => {
    if (!query || !text) return text; // If no query or text, return as is

    const regex = new RegExp(`(${query})`, 'gi'); // Case-insensitive match
    return text.split(regex).map((part, index) =>
      part.toLowerCase() === query.toLowerCase() ? (
        <span
          key={index}
          style={{ backgroundColor: 'yellow', fontWeight: 'bold' }}
        >
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  const handlePublish = () => {
    let data = {
      user: user._id || user.id,
      id: comment.id,
      internality: !internality
    };

    dispatch(updateInstance(commentCategory)(data)).then(({ payload }) => {
      setInternality((prev) => !prev);
    });
  };

  return (
    <Card className="p-0 w-full shadow-none rounded-none">
      <CardHeader
        title={
          comment.title ? (
            <>
              <Typography className="text-14 font-semibold">
                {highlightText(comment.title, trimmedSearchText)}
              </Typography>
            </>
          ) : null
        }
        action={
          <CommentStatusBar comment={comment} internality={internality} />
        }
        className="p-16 pb-8"
      />
      <CardContent className="max-w-full py-0 px-16 text-14">
        {highlightText(comment.content, trimmedSearchText)}
      </CardContent>
      <CardActions className="flex p-16">
        {authRoles.editor.includes(user.role) &&
          (internality ? (
            <Button
              variant="text"
              aria-label="Publish"
              startIcon={
                <BASESvgIcon size={16}>heroicons-outline:eye</BASESvgIcon>
              }
              className="justify-end mr-8"
              onClick={() => handlePublish()}
            >
              Publish
            </Button>
          ) : (
            <Button
              variant="text"
              aria-label="Unpublish"
              startIcon={
                <BASESvgIcon size={16}>heroicons-outline:eye-off</BASESvgIcon>
              }
              className="justify-end mr-8"
              onClick={() => handlePublish()}
            >
              Unpublish
            </Button>
          ))}
        {(user.id === comment?.creator?.id ||
          authRoles.leadEditor.includes(user.role)) && (
          <Button
            variant="text"
            aria-label="Unpublish"
            startIcon={
              <BASESvgIcon size={16}>heroicons-outline:pencil-alt</BASESvgIcon>
            }
            className="justify-end mr-8"
            onClick={() => {
              console.log(comment);
            }}
            component={NavLinkAdapter}
            to={editLink}
          >
            Edit
          </Button>
        )}
        <Button
          variant="contained"
          color="secondary"
          size="small"
          aria-label="Reply"
          startIcon={
            <BASESvgIcon size={16}>heroicons-outline:reply</BASESvgIcon>
          }
          className="justify-end"
          component={NavLinkAdapter}
          to={replyLink}
        >
          Reply
        </Button>
      </CardActions>
    </Card>
  );
}

export default ReplyContentCard;
